import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import { saveAs } from "file-saver";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDDatePicker from "components/MDDatePicker";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Icon from "@mui/material/Icon";
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

import { API_ESA_OFFICE, API_ESA_OFFICE_UPLOAD } from "utils";
import { logoutUser } from "actions/AuthAction";

// API
import axios from "axios";

function PeminjamanAset() {
  const [peminjaman, setPeminjaman] = useState([]);
  const [tahun, setTahun] = useState(new Date().getFullYear().toString());
  const tahunList = ["2024", "2025", "2026", "2027"];
  const [searchNamaBarang, setSearchNamaBarang] = useState("");
  const [searchStatus, setSearchStatus] = useState("");
  const statusOptions = [
    { value: "Dipinjam", label: "Dipinjam" },
    { value: "Dikembalikan", label: "Dikembalikan" },
    { value: "Rusak", label: "Rusak" },
    { value: "Hilang", label: "Hilang" },
  ];
  const [openDialog, setOpenDialog] = useState(false);
  const [openKembalikanDialog, setOpenKembalikanDialog] = useState(false);
  const [selectedPeminjaman, setSelectedPeminjaman] = useState(null);
  const [formKembali, setFormKembali] = useState({
    catatan_pengembalian: "",
    tanggal_kembali: new Date(),
    status: "",
  });
  const [asetList, setAsetList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [formData, setFormData] = useState({
    aset_id: "",
    peminjam_id: "",
    jumlah_dipinjam: "",
    keperluan: "",
    tanggal_pinjam: new Date(),
  });
  const [userId, setUserId] = useState(null);
  const [dinasId, setDinasId] = useState(null);
  const [openDetailDialog, setOpenDetailDialog] = useState(false);
  const [selectedDetail, setSelectedDetail] = useState(null);
  const navigate = useNavigate();

  // Fungsi helper untuk format profil URL
  const formatProfilUrl = (profil, uid_RSS) => {
    if (uid_RSS) {
      return `https://smartdh.rotendaokab.go.id/uploads/${uid_RSS}.jpg`;
    }
    if (profil) {
      return `${API_ESA_OFFICE_UPLOAD}${profil}`;
    }
    return null;
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setUserId(user.uid);
      setDinasId(user.dinas_id);
    } else {
      logoutUser(navigate);
    }
  }, []);

  const handleOpenKembalikanDialog = (item) => {
    setSelectedPeminjaman(item);
    setOpenKembalikanDialog(true);
  };

  const handleKembalikan = async (id) => {
    try {
      await axios.put(`${API_ESA_OFFICE}aset/kembalikan/${id}`, formKembali);
      swal({
        title: "Berhasil!",
        text: "Aset berhasil dikembalikan",
        icon: "success",
        button: "OK",
      });
      setOpenKembalikanDialog(false);
      setFormKembali({
        catatan_pengembalian: "",
        tanggal_kembali: new Date(),
      });
      fetchPeminjaman();
    } catch (error) {
      swal({
        title: "Error!",
        text:
          error.response?.data?.message ||
          "Terjadi kesalahan saat mengembalikan aset",
        icon: "error",
        button: "OK",
      });
    }
  };

  const handleOpenDetail = (item) => {
    setSelectedDetail(item);
    setOpenDetailDialog(true);
  };

  const columns = [
    { Header: "Tanggal Pinjam", accessor: "tanggal_pinjam", width: "12%" },
    { Header: "Tanggal Kembali", accessor: "tanggal_kembali", width: "12%" },
    { Header: "Nama Barang", accessor: "nama_barang", width: "15%" },
    { Header: "Kode Barang", accessor: "kodeBarang", width: "10%" },
    {
      Header: "Peminjam",
      accessor: "nama_peminjam",
      width: "15%",
      Cell: ({ row }) => {
        const profilUrl = formatProfilUrl(
          row.original.profil,
          row.original.uid_RSS
        );
        return (
          <MDBox display="flex" alignItems="center">
            {profilUrl && (
              <img
                src={profilUrl}
                alt={row.original.nama_peminjam}
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  marginRight: 8,
                }}
              />
            )}
            <MDTypography variant="caption" fontWeight="medium">
              {row.original.nama_peminjam}
            </MDTypography>
          </MDBox>
        );
      },
    },
    { Header: "Jumlah", accessor: "jumlah_dipinjam", width: "8%" },
    {
      Header: "Status",
      accessor: "status",
      width: "10%",
      Cell: ({ value }) => (
        <MDTypography
          variant="caption"
          fontWeight="medium"
          color={
            value === "Dikembalikan"
              ? "success"
              : value === "Dipinjam"
              ? "warning"
              : "error"
          }
        >
          {value}
        </MDTypography>
      ),
    },
    {
      Header: "Aksi",
      accessor: "aksi",
      width: "18%",
      Cell: ({ row }) => (
        <MDBox>
          {row.original.status === "Dipinjam" && (
            <MDButton
              variant="contained"
              color="success"
              size="small"
              onClick={() => handleOpenKembalikanDialog(row.original)}
              sx={{ mr: 1 }}
            >
              Kembalikan
            </MDButton>
          )}
          <MDButton
            variant="contained"
            color="info"
            size="small"
            onClick={() => handleOpenDetail(row.original)}
          >
            Detail
          </MDButton>
        </MDBox>
      ),
    },
  ];

  useEffect(() => {
    if (dinasId) {
      fetchAsetList();
      fetchUserList();
      fetchPeminjaman();
    }
  }, [tahun, dinasId]);

  const fetchPeminjaman = async () => {
    try {
      const response = await axios.get(
        `${API_ESA_OFFICE}aset/peminjaman/tahun/dinas/${tahun}/${dinasId}`
      );
      const formattedData = response.data.data.map((item) => ({
        ...item,
        tanggal_pinjam: new Date(item.tanggal_pinjam).toLocaleDateString(
          "id-ID"
        ),
        tanggal_kembali: item.tanggal_kembali
          ? new Date(item.tanggal_kembali).toLocaleDateString("id-ID")
          : "-",
        profil_peminjam: item.profil_peminjam,
        aksi: (
          <MDBox>
            {item.status === "Dipinjam" && (
              <MDButton
                variant="contained"
                color="success"
                size="small"
                onClick={() => handleOpenKembalikanDialog(item)}
                sx={{ mr: 1 }}
              >
                Kembalikan
              </MDButton>
            )}
            <MDButton
              variant="contained"
              color="info"
              size="small"
              onClick={() => handleOpenDetail(item)}
            >
              Detail
            </MDButton>
          </MDBox>
        ),
      }));
      setPeminjaman(formattedData);
    } catch (error) {
      console.error("Error fetching peminjaman:", error);
    }
  };

  const fetchAsetList = async () => {
    try {
      if (!dinasId) {
        console.error("Dinas ID tidak tersedia");
        return;
      }
      const response = await axios.get(
        `${API_ESA_OFFICE}aset/dinas/${dinasId}`
      );
      setAsetList(response.data);
    } catch (error) {
      console.error("Error fetching aset:", error);
    }
  };

  const fetchUserList = async () => {
    try {
      const response = await axios.get(
        `${API_ESA_OFFICE}users/dinas/${dinasId}`
      );
      const formattedUsers = response.data.map((user) => ({
        value: user.user_id,
        label: user.nama,
        avatar: formatProfilUrl(user.profil, user.uid_RSS),
        uid_RSS: user.uid_RSS,
      }));
      setUserList(formattedUsers);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleSubmit = async () => {
    try {
      await axios.post(`${API_ESA_OFFICE}aset/pinjam`, formData);
      swal({
        title: "Berhasil!",
        text: "Aset berhasil dipinjamkan",
        icon: "success",
        button: "OK",
      });
      setOpenDialog(false);
      fetchPeminjaman();
      setFormData({
        aset_id: "",
        peminjam_id: "",
        jumlah_dipinjam: "",
        keperluan: "",
        tanggal_pinjam: new Date(),
      });
    } catch (error) {
      console.error("Error submitting peminjaman:", error);
      swal({
        title: "Error!",
        text:
          error.response?.data?.message ||
          "Terjadi kesalahan saat meminjam aset",
        icon: "error",
        button: "OK",
      });
    }
  };

  const handleExportExcel = () => {
    if (!filteredPeminjaman.length) {
      swal({
        title: "Info",
        text: "Tidak ada data untuk di-export",
        icon: "info",
        button: "OK",
      });
      return;
    }

    // Buat HTML table untuk Excel
    const tableHeaders = [
      "No",
      "Tanggal Pinjam",
      "Tanggal Kembali",
      "Nama Barang",
      "Kode Barang",
      "Peminjam",
      "Jumlah",
      "Status",
      "Keperluan",
      "Catatan Pengembalian",
    ];

    let tableRows = "";
    filteredPeminjaman.forEach((item, index) => {
      tableRows += `
        <tr>
          <td>${index + 1}</td>
          <td>${item.tanggal_pinjam || ""}</td>
          <td>${item.tanggal_kembali || "-"}</td>
          <td>${item.nama_barang || ""}</td>
          <td>${item.kodeBarang || ""}</td>
          <td>${item.nama_peminjam || ""}</td>
          <td>${item.jumlah_dipinjam || ""}</td>
          <td>${item.status || ""}</td>
          <td>${item.keperluan || ""}</td>
          <td>${item.catatan_pengembalian || ""}</td>
        </tr>
      `;
    });

    const htmlContent = `
      <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
        <head>
          <meta charset="UTF-8">
          <title>Data Peminjaman Aset - ${tahun}</title>
          <style>
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; font-weight: bold; }
          </style>
        </head>
        <body>
          <h2>Data Peminjaman Aset</h2>
          <h3>Tahun: ${tahun}</h3>
          <p>Total Peminjaman: ${filteredPeminjaman.length} item</p>
          <p>Tanggal Export: ${new Date().toLocaleDateString("id-ID")}</p>
          <table>
            <thead>
              <tr>
                ${tableHeaders.map((header) => `<th>${header}</th>`).join("")}
              </tr>
            </thead>
            <tbody>
              ${tableRows}
            </tbody>
          </table>
        </body>
      </html>
    `;

    const blob = new Blob([htmlContent], {
      type: "application/vnd.ms-excel;charset=utf-8",
    });
    saveAs(blob, `peminjaman-aset-${tahun}.xls`);
  };

  const filteredPeminjaman = peminjaman.filter((item) => {
    const matchNamaBarang = item.nama_barang
      .toLowerCase()
      .includes(searchNamaBarang.toLowerCase());
    const matchStatus = searchStatus ? item.status === searchStatus : true;
    return matchNamaBarang && matchStatus;
  });

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDBox mb={3}>
          <MDTypography variant="h4">Manajemen Peminjaman Aset</MDTypography>
        </MDBox>

        <MDBox mb={3}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
              <MDInput
                type="text"
                label="Cari Nama Barang"
                fullWidth
                value={searchNamaBarang}
                onChange={(e) => setSearchNamaBarang(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <Icon sx={{ mr: 1, color: "text.secondary" }}>search</Icon>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <Autocomplete
                options={statusOptions}
                value={searchStatus}
                onChange={(event, newValue) => {
                  setSearchStatus(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Filter Status" fullWidth />
                )}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <Autocomplete
                options={tahunList}
                value={tahun}
                onChange={(event, newValue) => {
                  setTahun(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Pilih Tahun" fullWidth />
                )}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <MDButton
                variant="outlined"
                color="dark"
                onClick={handleExportExcel}
                disabled={!filteredPeminjaman.length}
                fullWidth
              >
                <Icon>description</Icon>
                &nbsp;Export Excel
              </MDButton>
            </Grid>
            <Grid item xs={12} md={3}>
              <MDButton
                variant="gradient"
                color="info"
                onClick={() => setOpenDialog(true)}
                fullWidth
              >
                <Icon>add</Icon>&nbsp;Tambah Peminjaman
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>

        <DataTable
          table={{
            columns,
            rows: filteredPeminjaman,
          }}
          entriesPerPage={false}
          showTotalEntries={false}
          isSorted={false}
          noEndBorder
        />

        <Dialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Tambah Peminjaman Aset</DialogTitle>

          <DialogContent>
            <MDBox mt={2}>
              <Autocomplete
                options={asetList}
                getOptionLabel={(option) =>
                  `${option.nama_barang} (${option.kodeBarang})`
                }
                onChange={(event, newValue) => {
                  setFormData({ ...formData, aset_id: newValue?.id });
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Pilih Aset" fullWidth />
                )}
              />
            </MDBox>
            <MDBox mt={2}>
              <Autocomplete
                options={userList}
                value={
                  userList.find(
                    (user) => user.value === formData.peminjam_id
                  ) || null
                }
                onChange={(event, newValue) => {
                  setFormData({ ...formData, peminjam_id: newValue?.value });
                }}
                renderInput={(params) => (
                  <MDInput
                    {...params}
                    label="Pilih Peminjam"
                    variant="standard"
                  />
                )}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      {...getTagProps({ index })}
                      key={option.value}
                      label={option.label}
                      avatar={
                        option.avatar ? (
                          <img
                            src={option.avatar}
                            alt={option.label}
                            style={{
                              width: 24,
                              height: 24,
                              borderRadius: "50%",
                            }}
                          />
                        ) : null
                      }
                    />
                  ))
                }
                renderOption={(props, option) => (
                  <li {...props}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      {option.avatar && (
                        <img
                          src={option.avatar}
                          alt={option.label}
                          style={{
                            width: 24,
                            height: 24,
                            borderRadius: "50%",
                          }}
                        />
                      )}
                      <span>{option.label}</span>
                    </div>
                  </li>
                )}
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                type="number"
                label="Jumlah Dipinjam"
                fullWidth
                value={formData.jumlah_dipinjam}
                onChange={(e) =>
                  setFormData({ ...formData, jumlah_dipinjam: e.target.value })
                }
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                type="text"
                label="Keperluan"
                fullWidth
                value={formData.keperluan}
                onChange={(e) =>
                  setFormData({ ...formData, keperluan: e.target.value })
                }
              />
            </MDBox>
            <MDBox mt={2}>
              <MDDatePicker
                label="Tanggal Pinjam"
                value={formData.tanggal_pinjam}
                onChange={(newValue) =>
                  setFormData({ ...formData, tanggal_pinjam: newValue })
                }
              />
            </MDBox>
          </DialogContent>
          <DialogActions>
            <MDButton onClick={() => setOpenDialog(false)}>Batal</MDButton>
            <MDButton onClick={handleSubmit} variant="gradient" color="info">
              Simpan
            </MDButton>
          </DialogActions>
        </Dialog>

        {/* Dialog Pengembalian Aset */}
        <Dialog
          open={openKembalikanDialog}
          onClose={() => setOpenKembalikanDialog(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Konfirmasi Pengembalian Aset</DialogTitle>
          <DialogContent>
            {selectedPeminjaman && (
              <MDBox mt={2}>
                <MDTypography variant="h6" mb={2}>
                  Detail Aset:
                </MDTypography>
                <MDTypography variant="body2">
                  Nama Barang: {selectedPeminjaman.nama_barang}
                </MDTypography>
                <MDTypography variant="body2">
                  Kode Barang: {selectedPeminjaman.kodeBarang}
                </MDTypography>
                <MDTypography variant="body2">
                  Peminjam: {selectedPeminjaman.nama_peminjam}
                </MDTypography>
                <MDTypography variant="body2">
                  Jumlah: {selectedPeminjaman.jumlah_dipinjam}
                </MDTypography>
              </MDBox>
            )}
            <MDBox mt={3}>
              <Autocomplete
                options={statusOptions}
                getOptionLabel={(option) => option.label}
                value={
                  statusOptions.find(
                    (option) => option.value === formKembali.status
                  ) || null
                }
                onChange={(event, newValue) => {
                  setFormKembali({
                    ...formKembali,
                    status: newValue ? newValue.value : "",
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Status Pengembalian"
                    fullWidth
                  />
                )}
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                type="text"
                label="Catatan Pengembalian"
                fullWidth
                multiline
                rows={3}
                value={formKembali.catatan_pengembalian}
                onChange={(e) =>
                  setFormKembali({
                    ...formKembali,
                    catatan_pengembalian: e.target.value,
                  })
                }
              />
            </MDBox>
            <MDBox mt={2}>
              <MDDatePicker
                label="Tanggal Kembali"
                value={formKembali.tanggal_kembali}
                onChange={(newValue) =>
                  setFormKembali({
                    ...formKembali,
                    tanggal_kembali: newValue,
                  })
                }
              />
            </MDBox>
          </DialogContent>
          <DialogActions>
            <MDButton onClick={() => setOpenKembalikanDialog(false)}>
              Batal
            </MDButton>
            <MDButton
              onClick={() => handleKembalikan(selectedPeminjaman?.id)}
              variant="gradient"
              color="success"
            >
              Konfirmasi Kembalikan
            </MDButton>
          </DialogActions>
        </Dialog>

        {/* Dialog Detail Peminjaman */}
        <Dialog
          open={openDetailDialog}
          onClose={() => setOpenDetailDialog(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Detail Peminjaman Aset</DialogTitle>
          <DialogContent>
            {selectedDetail && (
              <MDBox mt={2}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <MDTypography variant="h6" mb={2}>
                      Informasi Aset
                    </MDTypography>
                    <MDTypography variant="body2">
                      Nama Barang: {selectedDetail.nama_barang}
                    </MDTypography>
                    <MDTypography variant="body2">
                      Kode Barang: {selectedDetail.kodeBarang}
                    </MDTypography>
                  </Grid>
                  <Grid item xs={12}>
                    <MDTypography variant="h6" mb={2}>
                      Informasi Peminjaman
                    </MDTypography>
                    <MDTypography variant="body2">
                      Peminjam: {selectedDetail.nama_peminjam}
                    </MDTypography>
                    <MDTypography variant="body2">
                      Jumlah: {selectedDetail.jumlah_dipinjam}
                    </MDTypography>
                    <MDTypography variant="body2">
                      Tanggal Pinjam: {selectedDetail.tanggal_pinjam}
                    </MDTypography>
                    <MDTypography variant="body2">
                      Tanggal Kembali: {selectedDetail.tanggal_kembali}
                    </MDTypography>
                    <MDTypography variant="body2">
                      Status: {selectedDetail.status}
                    </MDTypography>
                    {selectedDetail.catatan_pengembalian && (
                      <MDTypography variant="body2">
                        Catatan Pengembalian:{" "}
                        {selectedDetail.catatan_pengembalian}
                      </MDTypography>
                    )}
                  </Grid>
                </Grid>
              </MDBox>
            )}
          </DialogContent>
          <DialogActions>
            <MDButton onClick={() => setOpenDetailDialog(false)}>
              Tutup
            </MDButton>
          </DialogActions>
        </Dialog>
      </MDBox>
    </DashboardLayout>
  );
}

export default PeminjamanAset;
